import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppUsersDto } from '../model/app-users-dto';
import { LoggedInUserKeys, LoggedInUserService } from '../service/logged-in-user.service';
import { REPORT_VIEWER_ROLES, savePostLoginRedirect } from '../utils/post-login-redirect';

/**
 * Gate for the shared assessment report (/assessment/public?token=...).
 * The token identifies the report; this guard additionally requires a signed-in
 * HR. Anyone else goes to the HR sign-in page and is brought back to the same
 * link once they have logged in.
 */
export const hrReportGuard: CanActivateFn = (route, state) => {
  const loggedInUserService = inject(LoggedInUserService);
  const router = inject(Router);
  const toaster = inject(ToastrService);

  const loggedInUser: AppUsersDto = loggedInUserService.getLoggedInUser(
    LoggedInUserKeys.LOGGED_IN_USER
  );
  if (loggedInUserService.isLoggedIn() && REPORT_VIEWER_ROLES.includes(loggedInUser.userRole)) {
    return true;
  }

  savePostLoginRedirect(state.url);
  toaster.info('Sign in with your HR account to view this report.');
  return router.parseUrl('/admin/sign-in');
};
